import { QueryFactory } from "../../../../Common";
import { Casino } from "../../../../Contracts";
export const QGetCategories = QueryFactory(Casino.QueryTypes.GetCategories);
//# sourceMappingURL=QGetCategories.js.map